export const REQUEST_TICKET_ASSIGNMENT_ACTION = 'REQUEST_TICKET_ASSIGNMENT_ACTION'
export const RECEIVE_TICKET_ASSIGNMENT_SUCCESS = 'RECEIVE_TICKET_ASSIGNMENT_SUCCESS'
export const RECEIVE_TICKET_ASSIGNMENT_FAILURE = 'RECEIVE_TICKET_ASSIGNMENT_FAILURE'
export const CLEAR_TICKET_ASSIGNMENT_ERRORS = 'CLEAR_TICKET_ASSIGNMENT_ERRORS'
